<template>
	<div class="show-fullscreen">
		<router-view></router-view>
	</div>
</template>

<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
	name: 'DEXPRO Platform',
})
</script>

<style lang="scss" scoped>

.show-fullscreen {
	height: 100vh;
}

</style>
